import setNotes from './setNotes';
import setMoreNotes from './setMoreNotes';
import reset from './reset';

export default {
  setNotes,
  setMoreNotes,
  reset,
};
